"use strict";
/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedDiscountCollateralAuctionHouse = void 0;
var geb_contract_base_1 = require("@reflexer-finance/geb-contract-base");
var FixedDiscountCollateralAuctionHouse = /** @class */ (function (_super) {
    __extends(FixedDiscountCollateralAuctionHouse, _super);
    function FixedDiscountCollateralAuctionHouse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FixedDiscountCollateralAuctionHouse.prototype.AUCTION_HOUSE_TYPE = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "AUCTION_HOUSE_TYPE", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.AUCTION_TYPE = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "AUCTION_TYPE", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.addAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "addAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.amountToRaise = function (id, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "amountToRaise", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [id], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.auctionsStarted = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "auctionsStarted", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.authorizedAccounts = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "authorizedAccounts", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.bidAmount = function (id, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "bidAmount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [id], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.bids = function (uinteger, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "bids", "outputs": [{ "internalType": "uint256", "name": "raisedAmount", "type": "uint256" }, { "internalType": "uint256", "name": "soldAmount", "type": "uint256" }, { "internalType": "uint256", "name": "amountToSell", "type": "uint256" }, { "internalType": "uint256", "name": "amountToRaise", "type": "uint256" }, { "internalType": "uint48", "name": "auctionDeadline", "type": "uint48" }, { "internalType": "address", "name": "forgoneCollateralReceiver", "type": "address" }, { "internalType": "address", "name": "auctionIncomeRecipient", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [uinteger], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.buyCollateral = function (id, wad) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "wad", "type": "uint256" }], "name": "buyCollateral", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id, wad]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.collateralFSM = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "collateralFSM", "outputs": [{ "internalType": "contract OracleLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.collateralType = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "collateralType", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.discount = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "discount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.forgoneCollateralReceiver = function (id, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "forgoneCollateralReceiver", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [id], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getAdjustedBid = function (id, wad, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "wad", "type": "uint256" }], "name": "getAdjustedBid", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [id, wad], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getApproximateCollateralBought = function (id, wad, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "wad", "type": "uint256" }], "name": "getApproximateCollateralBought", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [id, wad], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getCollateralBought = function (id, wad) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "wad", "type": "uint256" }], "name": "getCollateralBought", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id, wad]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getCollateralFSMAndFinalSystemCoinPrices = function (systemCoinRedemptionPrice, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "systemCoinRedemptionPrice", "type": "uint256" }], "name": "getCollateralFSMAndFinalSystemCoinPrices", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [systemCoinRedemptionPrice], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getCollateralMedianPrice = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getCollateralMedianPrice", "outputs": [{ "internalType": "uint256", "name": "priceFeed", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getDiscountedCollateralPrice = function (collateralFsmPriceFeedValue, collateralMedianPriceFeedValue, systemCoinPriceFeedValue, customDiscount, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "collateralFsmPriceFeedValue", "type": "uint256" }, { "internalType": "uint256", "name": "collateralMedianPriceFeedValue", "type": "uint256" }, { "internalType": "uint256", "name": "systemCoinPriceFeedValue", "type": "uint256" }, { "internalType": "uint256", "name": "customDiscount", "type": "uint256" }], "name": "getDiscountedCollateralPrice", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [
            collateralFsmPriceFeedValue,
            collateralMedianPriceFeedValue,
            systemCoinPriceFeedValue,
            customDiscount,
        ], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getFinalBaseCollateralPrice = function (collateralFsmPriceFeedValue, collateralMedianPriceFeedValue, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "collateralFsmPriceFeedValue", "type": "uint256" }, { "internalType": "uint256", "name": "collateralMedianPriceFeedValue", "type": "uint256" }], "name": "getFinalBaseCollateralPrice", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [collateralFsmPriceFeedValue, collateralMedianPriceFeedValue], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getSystemCoinCeilingDeviatedPrice = function (redemptionPrice, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "redemptionPrice", "type": "uint256" }], "name": "getSystemCoinCeilingDeviatedPrice", "outputs": [{ "internalType": "uint256", "name": "ceilingPrice", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [redemptionPrice], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getSystemCoinFloorDeviatedPrice = function (redemptionPrice, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "redemptionPrice", "type": "uint256" }], "name": "getSystemCoinFloorDeviatedPrice", "outputs": [{ "internalType": "uint256", "name": "floorPrice", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [redemptionPrice], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.getSystemCoinMarketPrice = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getSystemCoinMarketPrice", "outputs": [{ "internalType": "uint256", "name": "priceFeed", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.lastReadRedemptionPrice = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "lastReadRedemptionPrice", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.liquidationEngine = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "liquidationEngine", "outputs": [{ "internalType": "contract LiquidationEngineLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.lowerCollateralMedianDeviation = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "lowerCollateralMedianDeviation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.lowerSystemCoinMedianDeviation = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "lowerSystemCoinMedianDeviation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.minSystemCoinMedianDeviation = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "minSystemCoinMedianDeviation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.minimumBid = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "minimumBid", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.modifyParameters__Bytes32Address = function (parameter, data) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "address", "name": "data", "type": "address" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, data]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.modifyParameters__Bytes32Uint256 = function (parameter, data) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "uint256", "name": "data", "type": "uint256" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, data]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.oracleRelayer = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "oracleRelayer", "outputs": [{ "internalType": "contract OracleRelayerLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.raisedAmount = function (id, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "raisedAmount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [id], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.remainingAmountToSell = function (id, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "remainingAmountToSell", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [id], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.removeAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "removeAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.safeEngine = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "safeEngine", "outputs": [{ "internalType": "contract SAFEEngineLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.settleAuction = function (id) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "settleAuction", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.startAuction = function (forgoneCollateralReceiver, auctionIncomeRecipient, amountToRaise, amountToSell, initialBid) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "forgoneCollateralReceiver", "type": "address" }, { "internalType": "address", "name": "auctionIncomeRecipient", "type": "address" }, { "internalType": "uint256", "name": "amountToRaise", "type": "uint256" }, { "internalType": "uint256", "name": "amountToSell", "type": "uint256" }, { "internalType": "uint256", "name": "initialBid", "type": "uint256" }], "name": "startAuction", "outputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [
            forgoneCollateralReceiver,
            auctionIncomeRecipient,
            amountToRaise,
            amountToSell,
            initialBid,
        ]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.systemCoinOracle = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "systemCoinOracle", "outputs": [{ "internalType": "contract OracleLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.terminateAuctionPrematurely = function (id) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "terminateAuctionPrematurely", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id]);
    };
    FixedDiscountCollateralAuctionHouse.prototype.totalAuctionLength = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "totalAuctionLength", "outputs": [{ "internalType": "uint48", "name": "", "type": "uint48" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.upperCollateralMedianDeviation = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "upperCollateralMedianDeviation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    FixedDiscountCollateralAuctionHouse.prototype.upperSystemCoinMedianDeviation = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "upperSystemCoinMedianDeviation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    return FixedDiscountCollateralAuctionHouse;
}(geb_contract_base_1.BaseContractAPI));
exports.FixedDiscountCollateralAuctionHouse = FixedDiscountCollateralAuctionHouse;
